<template lang="pug">
  .content
    .md-layout.md-gutter.md-alignment-center-center
      .md-layout-item.md-size-55.md-medium-size-70.md-xsmall-size-100
        md-card(v-if="!noVote && voted")
          md-card-header(data-background-color="green")
            h4(class="title") Open New Position: {{pitch.stock_name}}
          md-card-content
            NewPositionForm(:pitch_id="pitch.id" :position="final_position")
        md-card(v-else)
          md-card-header(data-background-color="green")
            h4(class="title" v-if="!pitch") Vote
            h4(class="title" v-else) Vote: {{pitch.direction}} {{pitch.stock_name}}
            p(class="category") Place your vote for the general meeting pitch.
          md-card-content
            form(@submit.prevent="")
              .md-layout(v-if="noVote")
                .text-center.md-layout-item.md-size-100
                  h4 There's currently no active pitch to vote on!
              .md-layout(v-else-if="pitch")
                .md-layout-item.md-size-100
                  .md-layout-item.md-size-100
                    p What is your position?
                    md-field
                      md-select(v-model="position" required placeholder="Select...")
                        md-option(value="LONG") Long
                        md-option(value="SHORT") Short
                        md-option(value="ABSTAIN") Abstain 
                  .md-layout-item.md-size-100
                    p Do you have any comments for the pitch?
                    md-field
                      md-textarea(v-model="comments" name="comments" id="comments" placeholder="Comments...")
                  .text-center.md-layout-item
                    h6(v-if="error" style="color: red") Sorry, there was an error placing your vote. Please try again
                    md-button(type="submit" v-on:click="placeVote") Place Vote
              .md-layout(v-else-if="initialError")
                .text-center.md-layout-item.md-size-100
                  h4(style="color: red") Sorry, there was an error retrieving the current pitch. Please try again
</template>

<script>
import axios from 'axios';
import NewPositionForm from './NewPositionForm.vue';

export default {
  components: {
    NewPositionForm,
  },
  data() {
    return{
      position: null,
      comments: null,
      error: false,
      initialError: false,
      noVote: false,
      pitch: null,
      voted: false,
      final_position: null,
    };
  },
  created() {
    //get data and make sure valid meeting & have not already voted
    this.user = this.$store.state.user;
    this.getPitch();
  },
  mounted() {

  },
  methods: {
    placeVote() {
      this.resetErrors();
      if (this.position) {
        let load = {
          position: this.position,
          comments: this.comments
        };
        axios.post(`/api/org/vote/${this.pitch.id}`, load)
        .then((response) => {
          if(response.data.status) {
            this.voted = true;
            this.final_position = this.position;
          } else {
            this.error = true;
          }
        }).catch((err) => {
          this.error = true;
        });
      }
    },
    getPitch() {
      axios.get('/api/org/get_current_pitch')
      .then((response) => {
        this.pitch = response.data.pitch;
        if (response.data.novote) {
          this.noVote = true;
        } else if (response.data.voted) {
          this.voted = true;
          this.final_position = response.data.position;
        }
      }).catch(() => {
        this.initialError = true;
      });
    },
    resetErrors() {
      this.error = null;
      this.success = null;
      this.initialError = null;
    }
  }
}
</script>

<style scoped>
  form{
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Trading/Vote.vue